import { TemplateRef, Directive } from "@angular/core";
import { NgOption } from "@ng-select/ng-select";
import { ListOption } from "../../models/list-option";

@Directive({
    selector: "[select-option-tmp]",
    standalone: false
})
export class SelectOptionTemplateDirective {
  constructor(
    public template: TemplateRef<SelectOptionTemplateDirectiveContext>
  ) {}
}

@Directive({
    selector: "[select-label-tmp]",
    standalone: false
})
export class SelectLabelTemplateDirective {
  constructor(
    public template: TemplateRef<SelectLabelTemplateDirectiveContext>
  ) {}
}

export interface SelectOptionTemplateDirectiveContext {
  option: ListOption<number | string>;
  item: NgOption;
  searchTerm: string;
  index: number;
}

export interface SelectLabelTemplateDirectiveContext {
  option: ListOption<number | string>;
  clear: (option: ListOption<number | string>) => void;
  label: string;
}
